import type { FC } from "react";
import { useCallback, useEffect, useState } from "react";

import { useSelector } from "@jti/store/reduxHooks";
import { selectDefaultBillingAddress } from "@jti/store/selectors/selectDefaultBillingAddress";
import { AddressInfoBlock, useCountry, useTranslations } from "@jti/ui";

import { SHIPPING_FORM_FIELDS } from "@checkout/forms/ShippingForm/constants";

import { useShippingFormContext } from "../../../hooks/useShippingFormContext";
import CustomBillingAddress from "../BillingAddressEditForm";

export const BillingAddressAlternativeDelivery: FC = () => {
  const { __ } = useTranslations();
  const [isEditModeOn, setEditMode] = useState(false);
  const country = useCountry();
  const defaultBillingAddress = useSelector((state) => selectDefaultBillingAddress(state, country));
  const formContext = useShippingFormContext();

  const shouldUseInStoreDeliveryBillingAddress = formContext.watch("shouldUseInStoreDeliveryBillingAddress");

  const showEditBillingAddressForm = useCallback(() => {
    const populateAddressFields = () => {
      formContext.setValue(SHIPPING_FORM_FIELDS.billingAddressType, "custom");
      formContext.setValue(SHIPPING_FORM_FIELDS.billingAddress, {
        ...formContext.getValues(SHIPPING_FORM_FIELDS.billingAddress),
        ...defaultBillingAddress,
      });
    };

    if (defaultBillingAddress) {
      populateAddressFields();
    }

    setEditMode(true);
  }, [defaultBillingAddress, formContext]);

  useEffect(() => {
    const isCustomBillingAddress = isEditModeOn || !defaultBillingAddress;

    formContext.setValue("shouldUseInStoreDeliveryBillingAddress", isCustomBillingAddress);
  }, [isEditModeOn, defaultBillingAddress]);

  return (
    <>
      {shouldUseInStoreDeliveryBillingAddress && <CustomBillingAddress />}

      {!shouldUseInStoreDeliveryBillingAddress && defaultBillingAddress && (
        <AddressInfoBlock
          address={defaultBillingAddress}
          editLabel={__("cart.button.edit_billing")}
          onEdit={showEditBillingAddressForm}
          hideTelephone
          isEditable
        />
      )}
    </>
  );
};
